import { Box, styled } from '@mui/material'

export const PortfolioContainer = styled(Box)(() => ({
  height: '100vh',
  maxHeight: '1000px',
  overflowY: 'scroll',
  scrollSnapType: 'y mandatory',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
}))

export const ProjectContainer = styled(Box)(({ theme }) => ({
  height: '100%',
  position: 'relative',
  scrollSnapAlign: 'start',
  [theme.breakpoints.up('lg')]: {
    paddingTop: '40px',
  },
}))
